/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback } from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import {
	Nav4Apps as Nav4AppsWithoutErrorBoundary,
	type Nav4AppsProps,
} from './ui/apps/Nav4Apps.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';
import { createAttributes } from './common/utils/get-attributes/index.tsx';

export const Nav4Apps = (props: Nav4AppsProps): React.JSX.Element => {
	const getAttributes = useCallback(
		(error: Error) => createAttributes({ error, component: 'Nav4Apps' }),
		[],
	);
	return (
		<UFOSegment name="nav4-sidebar-apps">
			<JSErrorBoundary
				fallback="flag"
				id="apps-section"
				attributes={getAttributes}
				packageName={PACKAGE_NAME}
				teamName={TEAM_NAME}
			>
				<Nav4AppsWithoutErrorBoundary {...props} />
			</JSErrorBoundary>
		</UFOSegment>
	);
};
